"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MBTooltip = exports.MBTooltipComic = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var core_1 = require("@material-ui/core");
var react_i18next_1 = require("react-i18next");
var mock_1 = require("../../utils/mock");
exports.MBTooltipComic = styled_components_1.default(function (_a) {
    var bgcolor = _a.bgcolor, color = _a.color, maxWidth = _a.maxWidth, padding = _a.padding, margin = _a.margin, popperCss = _a.popperCss, props = __rest(_a, ["bgcolor", "color", "maxWidth", "padding", "margin", "popperCss"]);
    mock_1.mockFunction({ bgcolor: bgcolor, color: color, maxWidth: maxWidth, padding: padding, margin: margin, popperCss: popperCss });
    return (jsx_runtime_1.jsx(core_1.Tooltip, __assign({ classes: {
            popper: props.className,
            tooltip: 'tooltip',
            arrow: 'arrow',
        } }, props), void 0));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & .tooltip {\n    background: ", ";\n    border: 1px solid ", ";\n    border-radius: 4px;\n    box-sizing: border-box;\n    box-shadow: 4px 4px 0 0 rgba(0, 0, 0, 0.2);\n    color: ", ";\n    max-width: ", ";\n    padding: ", ";\n    margin: ", ";\n  }\n  & .arrow {\n    color: ", ";\n    &:before {\n      border: 1px solid ", ";\n    }\n  }\n  ", "\n"], ["\n  & .tooltip {\n    background: ", ";\n    border: 1px solid ", ";\n    border-radius: 4px;\n    box-sizing: border-box;\n    box-shadow: 4px 4px 0 0 rgba(0, 0, 0, 0.2);\n    color: ", ";\n    max-width: ",
    ";\n    padding: ", ";\n    margin: ", ";\n  }\n  & .arrow {\n    color: ", ";\n    &:before {\n      border: 1px solid ", ";\n    }\n  }\n  ", "\n"])), function (_a) {
    var bgcolor = _a.bgcolor;
    return (bgcolor ? bgcolor : "#ffffff");
}, function (_a) {
    var color = _a.color;
    return (color ? color : "#000");
}, function (_a) {
    var color = _a.color;
    return (color ? color : "#000");
}, function (_a) {
    var maxWidth = _a.maxWidth;
    return maxWidth
        ? typeof maxWidth === 'number'
            ? maxWidth + "px"
            : "" + maxWidth
        : "240px";
}, function (_a) {
    var padding = _a.padding;
    return (padding ? padding : '16px');
}, function (_a) {
    var margin = _a.margin;
    return (margin ? margin : '5px 0');
}, function (_a) {
    var bgcolor = _a.bgcolor;
    return (bgcolor ? bgcolor : "#000");
}, function (_a) {
    var color = _a.color;
    return (color ? color : "#000");
}, function (_a) {
    var popperCss = _a.popperCss;
    return popperCss;
});
var MBTooltip = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    var t = react_i18next_1.useTranslation().t;
    return jsx_runtime_1.jsx(core_1.Tooltip, __assign({}, props, { title: typeof title === 'string' && t(title) }), void 0);
};
exports.MBTooltip = MBTooltip;
var templateObject_1;
//# sourceMappingURL=MBTooltip.js.map